import { Grid, styled } from "@mui/material";

export const Styled = {
    Container: styled("div")`
        padding: 20px;
        display: flex;
        justify-content: center;
        flex: 1;

        ${props => props.theme.breakpoints.down("md")} {
            padding: 20px 0;
        }
    `,
    Form: styled("form")`
        width: 90%;
        ${props => props.theme.breakpoints.down("sm")} {
            width: 100%;
        }
    `,
    Inputs: styled(Grid)`
        background-color: ${props => props.theme.palette.secondary.dark};
        border: 1px solid ${props => props.theme.palette.secondary.main};
        border-radius: 16px;
        padding: 32px;
        transition:
            border-color 0.5s ease,
            color 0.5s ease;

        &:hover {
            border-color: ${props => props.theme.palette.secondary.light};
        }

        ${props => props.theme.breakpoints.down("sm")} {
            border-radius: unset;
            display: flex;
            gap: 25px;

            & .MuiGrid-container {
                padding: 25px 0;
            }

            & .MuiGrid-item {
                display: flex;
                gap: 25px;
            }
        }
    `,
    Google: styled(Grid)`
        ${props => props.theme.breakpoints.down("sm")} {
            justify-content: center;
        }
    `,
};
